import { Assets, Texture } from 'pixi.js';

export class AssetManager {
  private static instance: AssetManager;
  private textures: Map<string, Texture> = new Map();
  private loaded = false;

  private constructor() {}

  public static getInstance(): AssetManager {
    if (!AssetManager.instance) {
      AssetManager.instance = new AssetManager();
    }
    return AssetManager.instance;
  }

  /**
   * Register a texture with the asset manager from an external source.
   * Used by MapRenderSystem and SpritesheetService to register textures.
   */
  public registerTexture(id: string, texture: Texture): void {
    this.textures.set(id, texture);
  }

  /**
   * Load non-spritesheet assets.
   * Spritesheet assets are loaded via SpritesheetService.loadSpritesheet().
   */
  public async loadAssets(): Promise<void> {
    if (this.loaded) return;

    // Non-spritesheet assets (static textures without animation data)
    const rabbitTexture = await Assets.load('/assets/bunny.png');
    this.textures.set('rabbit', rabbitTexture);

    this.loaded = true;
  }

  public getTexture(id: string): Texture {
    const texture = this.textures.get(id);
    if (!texture) {
      console.warn(`Texture not found: ${id}`);
      return Texture.EMPTY;
    }
    return texture;
  }

  public hasTexture(id: string): boolean {
    return this.textures.has(id);
  }
}
